'use client';

import { useEffect } from 'react';

import { loadGoogleRecaptcha } from '../Utils/loadGoogleRecaptcha';

export const useGoogleRecaptcha = () => {
  useEffect(() => {
    const loadScript = async () => {
      try {
        await loadGoogleRecaptcha();
      } catch (error) {
        console.error(error);
      }
    };
    loadScript();
  }, []);
};
